import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { styled } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button } from '../../../Controls/Button';
import Icons from '../../../Elements/Icons';
import { Select } from '../../Select';
const MonthSelectWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;
const MonthSelectContainer = styled.div `
  flex: 1;
`;
export const MonthSelect = memo(function MonthSelect({ date, changeMonth, changeYear, locale, dataTestId }) {
    const monthOptions = useMemo(() => {
        const formatter = new Intl.DateTimeFormat(locale, { month: 'long' });
        return Array.from({ length: 12 }, (_, index) => ({
            value: index,
            label: formatter.format(new Date(2000, index, 1)),
        }));
    }, [locale]);
    const value = useMemo(() => monthOptions[date.getMonth()], [date, monthOptions]);
    const handleChange = useCallbackRef((option) => {
        if (option) {
            changeMonth(option.value);
        }
    });
    const handlePrevMonth = useCallbackRef(() => {
        const currentMonth = date.getMonth();
        const currentYear = date.getFullYear();
        if (currentMonth === 0) {
            changeMonth(11);
            changeYear(currentYear - 1);
        }
        else {
            changeMonth(currentMonth - 1);
        }
    });
    const handleNextMonth = useCallbackRef(() => {
        const currentMonth = date.getMonth();
        const currentYear = date.getFullYear();
        if (currentMonth === 11) {
            changeMonth(0);
            changeYear(currentYear + 1);
        }
        else {
            changeMonth(currentMonth + 1);
        }
    });
    return (_jsxs(MonthSelectWrapper, { children: [_jsx(Button, { onClick: handlePrevMonth, ghost: true, iconOnly: true, dataTestId: dataTestId ? `${dataTestId}-month-prev` : undefined, children: _jsx(Icons.Chevron, { align: 'left', size: 20 }) }), _jsx(MonthSelectContainer, { children: _jsx(Select, { options: monthOptions, value: value, onChange: handleChange, dataTestId: dataTestId ? `${dataTestId}-month-select` : undefined }) }), _jsx(Button, { onClick: handleNextMonth, ghost: true, iconOnly: true, dataTestId: dataTestId ? `${dataTestId}-month-next` : undefined, children: _jsx(Icons.Chevron, { align: 'right', size: 20 }) })] }));
});
